import { siteMeta } from "../data/siteMeta.js";

export function resolvePageMeta({
  title, description, path = "/", image = siteMeta.defaultOgImage,
  type = "website", robots = "index,follow", themeColor = "#140f1c",
  keywords = "", jsonLd,
}) {
  const canonical = new URL(path, `${siteMeta.baseUrl}/`);
  canonical.search = "";
  canonical.hash = "";
  canonical.pathname = canonical.pathname.replace(/\/+$/, "") || "/";
  const imageUrl = new URL(image, `${siteMeta.baseUrl}/`).href;
  return {
    title,
    canonical: canonical.href,
    names: {
      description, keywords, robots, author: siteMeta.name,
      "theme-color": themeColor,
      "twitter:card": "summary_large_image",
      "twitter:title": title,
      "twitter:description": description,
      "twitter:image": imageUrl,
      "twitter:image:alt": title,
    },
    properties: {
      "og:type": type,
      "og:site_name": `${siteMeta.name} | ${siteMeta.title}`,
      "og:title": title,
      "og:description": description,
      "og:url": canonical.href,
      "og:image": imageUrl,
      "og:image:alt": title,
      "og:locale": "en_GB",
    },
    jsonLd: (Array.isArray(jsonLd) ? jsonLd : [jsonLd || {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: title,
      description,
      url: canonical.href,
      inLanguage: "en-GB",
    }]).filter(Boolean),
  };
}

const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (char) => ({
  "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
})[char]);

export function renderPageHead(meta) {
  return [
    `<title>${escapeHtml(meta.title)}</title>`,
    `<link rel="canonical" href="${escapeHtml(meta.canonical)}">`,
    ...Object.entries(meta.names).filter(([, value]) => value).map(([name, value]) =>
      `<meta name="${name}" content="${escapeHtml(value)}">`),
    ...Object.entries(meta.properties).map(([property, value]) =>
      `<meta property="${property}" content="${escapeHtml(value)}">`),
    ...meta.jsonLd.map((value) => `<script type="application/ld+json" data-seo-jsonld="true">${JSON.stringify(value).replace(/</g, "\\u003c")}</script>`),
  ].join("\n");
}
